import React from 'react'
import { Dropdown } from '../Dropdown'
import styles from './UserMenu.module.scss'
import { Avatar } from '../Avatar'
import { User } from '../../types/common'

interface UserMenuProps {
  user?: User
  options?: React.ReactElement[]
  loginLink?: React.ReactElement
}

export function UserMenu({ user, options, loginLink }: UserMenuProps) {
  return user && options ? (
    <Dropdown
      id='user-menu-logged-in'
      className={styles['hds-user-menu__container']}
      placement='bottom-end'
      trigger={
        <div className={styles['hds-user-menu']}>
          <div className={styles['hds-user-menu__avatar']}>
            <Avatar src={user.avatar} alt='user avatar' size='xxxs' />
          </div>
          <span
            className={styles['hds-user-menu__title']}
          >{`${user.firstName} ${user.lastName}`}</span>
        </div>
      }
      onSelectFocusedItem={(index: number) => {
        const { props } = options[index]
        if ('onClick' in props) {
          props.onClick()
        } else if ('onSelect' in props) {
          props.onSelect()
        } else if ('href' in props) {
          window.location.href = props.href
        }
      }}
    >
      {options.map((option, i) => (
        <Dropdown.Item key={i}>{option}</Dropdown.Item>
      ))}
    </Dropdown>
  ) : loginLink ? (
    <div className={styles['hds-user-menu__login']}>{loginLink}</div>
  ) : null
}
